<div class="detail-page">

  <!-- Skeleton loading state (two-column mirroring the workspace) -->
  <div class="workspace-skeleton" *ngIf="loading">

    <!-- Left skeleton: mirrors request-infos-panel -->
    <div class="skeleton-col">

      <div class="sk-panel-banner">
        <mat-icon class="sk-banner-icon">visibility</mat-icon>
        <span class="sk-banner-text">{{ 'request_v2.workspace.banner.citizen' | translate }}</span>
      </div>

      <div class="sk-tabs-bar">
        <div class="sk-tab sk-tab--active">{{ 'request_v2.workspace.tabs.infos' | translate }}</div>
        <div class="sk-tab">{{ 'request_v2.workspace.tabs.messages' | translate }}</div>
      </div>

      <div class="sk-scroll">
        <!-- request-header-card -->
        <div class="sk-request-header-card">

          <div class="sk-request-header">
            <div class="sk-icon-column">
              <app-skeleton-loader width="42px" height="42px" borderRadius="50%"></app-skeleton-loader>
              <app-skeleton-loader width="52px" height="22px" borderRadius="6px"></app-skeleton-loader>
            </div>
            <div class="sk-text-column">
              <app-skeleton-loader width="58%" height="18px"></app-skeleton-loader>
              <div class="sk-breadcrumb-row">
                <span class="sk-arrow">└</span>
                <app-skeleton-loader width="42%" height="15px"></app-skeleton-loader>
              </div>
              <div class="sk-breadcrumb-row sk-breadcrumb-row--dept">
                <span class="sk-arrow">└</span>
                <app-skeleton-loader width="28%" height="13px"></app-skeleton-loader>
              </div>
            </div>
            <div class="sk-status-column">
              <app-skeleton-loader width="80px" height="26px" borderRadius="13px"></app-skeleton-loader>
            </div>
          </div>

          <div class="sk-description-label-row">
            <span class="sk-section-label">{{ 'request_v2.info.situation_description' | translate }}</span>
          </div>
          <div class="sk-description-section">
            <div class="sk-description-box">
              <app-skeleton-loader width="100%" height="14px"></app-skeleton-loader>
              <app-skeleton-loader width="100%" height="14px"></app-skeleton-loader>
              <app-skeleton-loader width="75%" height="14px"></app-skeleton-loader>
            </div>
          </div>

          <div class="sk-info-sections">
            <div class="sk-info-section">
              <span class="sk-section-label">{{ 'request_v2.info.owner' | translate }}</span>
              <div class="sk-requester-row">
                <app-skeleton-loader width="26px" height="26px" shape="circle"></app-skeleton-loader>
                <app-skeleton-loader width="55%" height="14px"></app-skeleton-loader>
              </div>
              <div class="sk-contact-rows">
                <app-skeleton-loader width="80%" height="13px"></app-skeleton-loader>
                <app-skeleton-loader width="70%" height="13px"></app-skeleton-loader>
              </div>
            </div>
            <div class="sk-info-section">
              <span class="sk-section-label">{{ 'request_v2.info.location' | translate }}</span>
              <div class="sk-address-icon-row">
                <app-skeleton-loader width="14px" height="14px" borderRadius="2px"></app-skeleton-loader>
                <div class="sk-address-lines">
                  <app-skeleton-loader width="85%" height="13px"></app-skeleton-loader>
                  <app-skeleton-loader width="60%" height="13px"></app-skeleton-loader>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Right skeleton: mirrors request-internal-panel -->
    <div class="skeleton-col skeleton-col-right">

      <div class="sk-panel-meta-row">
        <div class="sk-internal-badge">
          <mat-icon class="sk-lock-icon">lock</mat-icon>
          <span class="sk-banner-text">{{ 'request_v2.workspace.badge.internal' | translate }}</span>
        </div>
        <div class="sk-panel-actions">
          <app-skeleton-loader width="28px" height="28px" borderRadius="6px"></app-skeleton-loader>
          <app-skeleton-loader width="28px" height="28px" borderRadius="6px"></app-skeleton-loader>
        </div>
      </div>

      <div class="sk-tabs-bar">
        <div class="sk-tab sk-tab--active">{{ 'request_v2.workspace.tabs.management' | translate }}</div>
        <div class="sk-tab">{{ 'request_v2.workspace.tabs.collaboration' | translate }}</div>
        <div class="sk-tab">{{ 'request_v2.workspace.tabs.history' | translate }}</div>
      </div>

      <div class="sk-dates-subheader">
        <app-skeleton-loader width="42px" height="12px"></app-skeleton-loader>
        <span class="sk-date-arrow">→</span>
        <app-skeleton-loader width="12px" height="12px" borderRadius="2px"></app-skeleton-loader>
        <app-skeleton-loader width="48px" height="12px"></app-skeleton-loader>
      </div>

      <div class="sk-sections-list">

        <div class="sk-section-block">
          <div class="sk-section-header">
            <span class="sk-section-title">{{ 'request_v2.workspace.section.tasks' | translate }}</span>
          </div>
          <div class="sk-section-content">
            <div class="sk-task-row">
              <app-skeleton-loader width="14px" height="14px" borderRadius="3px"></app-skeleton-loader>
              <app-skeleton-loader width="65%" height="13px"></app-skeleton-loader>
            </div>
            <div class="sk-task-row">
              <app-skeleton-loader width="14px" height="14px" borderRadius="3px"></app-skeleton-loader>
              <app-skeleton-loader width="48%" height="13px"></app-skeleton-loader>
            </div>
          </div>
        </div>

        <div class="sk-section-block">
          <div class="sk-section-header">
            <span class="sk-section-title">{{ 'request_v2.workspace.section.linked' | translate }}</span>
          </div>
          <div class="sk-section-content">
            <app-skeleton-loader width="100%" height="34px" borderRadius="8px"></app-skeleton-loader>
          </div>
        </div>

        <div class="sk-section-block">
          <div class="sk-section-header">
            <span class="sk-section-title">{{ 'request_v2.info.tags' | translate }}</span>
          </div>
          <div class="sk-section-content sk-section-content--row">
            <app-skeleton-loader width="62px" height="26px" borderRadius="13px"></app-skeleton-loader>
            <app-skeleton-loader width="78px" height="26px" borderRadius="13px"></app-skeleton-loader>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Workspace: two-column layout -->
  <div class="workspace" *ngIf="!loading && request">
    <!-- Left column: citizen-facing -->
    <div class="workspace-left">
      <app-request-infos-panel
        [request]="request"
        [canEdit]="canEdit"
        [isPolling]="pollingMessages"
        (requestChanged)="handleRequestChanged($event)"
        (messagesTabActivated)="onMessagesTabActivated()"
        (infosTabActivated)="onInfosTabActivated()">
      </app-request-infos-panel>
    </div>

    <!-- Right column: internal -->
    <div class="workspace-right">
      <app-request-internal-panel
        [request]="request"
        [canEdit]="canEdit"
        (requestChanged)="handleRequestChanged($event)"
        (refreshNeeded)="handleRefreshNeeded()"
        (closed)="goBack()"
        (navigateToRequest)="handleNavigateToRequest($event)">
      </app-request-internal-panel>
    </div>
  </div>

</div>
